import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <rect
        x="3"
        y="3"
        width="18"
        height="19"
        fill="currentColor"
        rx={props.rx}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5303 8.46967C17.8232 8.76256 17.8232 9.23744 17.5303 9.53033L11.5303 15.5303C11.2374 15.8232 10.7626 15.8232 10.4697 15.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697C7.76256 11.1768 8.23744 11.1768 8.53033 11.4697L11 13.9393L16.4697 8.46967C16.7626 8.17678 17.2374 8.17678 17.5303 8.46967Z"
        fill="White"
      />
    </SvgIcon>
  )
}

export default CheckIcon
